import { StyledButtonGroup } from '@app/components/button-group/ButtonGroup';
import { StyledButton } from '@app/components/button/Button';
import { TextField } from '@app/components/form-fields/TextField';
import type { AINumber } from '@app/services/api.types';
import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import type { UseFormReset } from 'react-hook-form';
import { Controller, useForm } from 'react-hook-form';
import { MdCheck } from 'react-icons/md';
import * as z from 'zod';

const schema = z.object({
    number: z.string().trim().min(1, 'Phone Number is required'),
});

export type NumberFormValues = z.infer<typeof schema>;

export type NumberFormProps = {
    id: string;
    data?: AINumber;
    loading?: boolean;
    onCancel?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onSubmit: (data: NumberFormValues, reset: UseFormReset<NumberFormValues>) => void;
};

export const NumberForm = ({ onSubmit, onCancel, data, ...props }: NumberFormProps) => {
    const {
        handleSubmit,
        control,
        reset,
        formState: { isValid, isSubmitting },
    } = useForm<NumberFormValues>({
        mode: 'all',
        resolver: zodResolver(schema),
        defaultValues: {
            number: '',
        },
    });

    useEffect(() => {
        reset(data);
    }, [data, reset]);

    return (
        <form onSubmit={handleSubmit((values) => onSubmit(values, reset))} id={props.id}>
            <div className="form-fields-wrapper">
                <div className="grid">
                    <div className="grid-xs-12">
                        <Controller
                            control={control}
                            name="number"
                            render={({ field, fieldState }) => (
                                <TextField
                                    fieldState={fieldState}
                                    {...field}
                                    label="Phone Number"
                                    type="text"
                                    placeholder="Enter phone number"
                                />
                            )}
                        />
                    </div>
                </div>
            </div>

            <div className="ant-modal-footer">
                <StyledButtonGroup justify="flex-end">
                    <StyledButton onClick={onCancel} color="black" data-testid="reset-button">
                        Cancel
                    </StyledButton>
                    <StyledButton
                        htmlType="submit"
                        type="primary"
                        disabled={!isValid}
                        loading={isSubmitting || props?.loading}
                        icon={<MdCheck />}
                        data-testid="add-number-button">
                        Save
                    </StyledButton>
                </StyledButtonGroup>
            </div>
        </form>
    );
};
